import { useNavigate } from 'react-router-dom'

export const HOME_URL = '/'

export const useGoToHomePage = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(HOME_URL + window.location.search)
    }
  }
}
